module.exports = __webpack_public_path__ + "img/swqu.0ad52a64.jpg";